exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-import-design-modal .import-design-header-name[data-v-19cd8838]{flex-shrink:0;margin-right:.75rem}", ""]);

// exports
